/**
 * @generated SignedSource<<6ae125358e5cc630094479d94710a828>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singlePersonKnowledgeCardRelay_workedOn$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly object: {
        readonly data: {
          readonly __typename: "BitbucketPullRequest";
          readonly href: AGG$URL | null | undefined;
        } | {
          readonly __typename: "ConfluenceBlogPost";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluencePage";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluenceWhiteboard";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ExternalDocument";
          readonly url: string | null | undefined;
        } | {
          readonly __typename: "JiraIssue";
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "LoomVideo";
          readonly loomUrl: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      };
    };
  }>;
  readonly " $fragmentType": "singlePersonKnowledgeCardRelay_workedOn";
};
export type singlePersonKnowledgeCardRelay_workedOn$key = {
  readonly " $data"?: singlePersonKnowledgeCardRelay_workedOn$data;
  readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_workedOn">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singlePersonKnowledgeCardRelay_workedOn",
  "selections": [
    {
      "concreteType": "ActivityItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ActivityNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "ActivityObject",
              "kind": "LinkedField",
              "name": "object",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluencePageLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluencePage"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceBlogPostLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluenceBlogPost"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceWhiteboardLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluenceWhiteboard"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "webUrl"
                        }
                      ],
                      "type": "JiraIssue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "url"
                        }
                      ],
                      "type": "ExternalDocument"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "href"
                        }
                      ],
                      "type": "BitbucketPullRequest"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": "loomUrl",
                          "kind": "ScalarField",
                          "name": "url"
                        }
                      ],
                      "type": "LoomVideo"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "ActivityConnection"
};
})();

(node as any).hash = "e28a3cc36fda4b5032a22a28b207c9f8";

export default node;
